  <section>
    <div *ngIf="isAppLoading && iframeMode !== IframeMode.NONE" class="chatbot-loader-overlay">
      <div class="chatbot-loader-container">
        <div class="chatbot-spinner"></div>
        <div class="chatbot-loader-text">Loading chatbot...</div>
      </div>
    </div>

    <div *ngIf="!showModal && iframeMode === IframeMode.NONE" id="" class="flex justify-end z-50">
      <button class="open-chat-model-btn floating-button" id="chatbot-toggle" (click)="openChatModal()">
        <img
            *ngIf="chatBotStyles.botWidgetIcon"
            [src]="chatBotStyles.botWidgetIcon"
            class="h-11 w-11 object-contain"
        />
      </button>
    </div>
    <div *ngIf="showModal" class="chat-backdrop" [class.standalone-fullscreen]="isStandaloneFullScreenMode" [class.fade-out]="isClosing">
      <app-chat-home [class.chat-window-enter]="!isClosing" [class.chat-window-exit]="isClosing"
        [isPhoneNumberSession]="isPhoneNumberSession"
        [urlParams]="urlParams"
        [iframeMode]="iframeMode"
        [hideCloseButton]="isStandaloneFullScreenMode"
        (closeModalEvent)="closeChatModal()">
      </app-chat-home>
    </div>
  </section>